import {
  __export
} from "./chunk.Y3TZ4FJV.js";

// src/components/icon/consts.ts
var consts_exports = {};
__export(consts_exports, {
  ARROW_RIGHT: () => ARROW_RIGHT,
  ARROW_RIGHT_MINI: () => ARROW_RIGHT_MINI,
  AUDIO: () => AUDIO,
  BURGER: () => BURGER,
  CALENDAR: () => CALENDAR,
  CHAT: () => CHAT,
  CHECKMARK: () => CHECKMARK,
  CHEVRON: () => CHEVRON,
  CLEAR: () => CLEAR,
  CLOSE: () => CLOSE,
  CLOSE_MODAL: () => CLOSE_MODAL,
  DELETE: () => DELETE,
  DISABLED: () => DISABLED,
  EMAIL: () => EMAIL,
  EXTERNAL_LINK: () => EXTERNAL_LINK,
  EYE: () => EYE,
  FILE: () => FILE,
  FILTER: () => FILTER,
  GLOBE: () => GLOBE,
  HANDLE: () => HANDLE,
  HEART: () => HEART,
  HEART_FILLED: () => HEART_FILLED,
  INFO: () => INFO,
  IT_ALERT: () => IT_ALERT,
  MINUS: () => MINUS,
  PEN: () => PEN,
  PEN_DETAILED: () => PEN_DETAILED,
  PERFORMANCE_DASHBOARD: () => PERFORMANCE_DASHBOARD,
  PHONE: () => PHONE,
  PLAY: () => PLAY,
  PLUS: () => PLUS,
  PROFILE: () => PROFILE,
  PROFILE_CIRCLE: () => PROFILE_CIRCLE,
  PROFILE_THIN: () => PROFILE_THIN,
  REFRESH: () => REFRESH,
  REPLY: () => REPLY,
  REPLY_WINDOWS: () => REPLY_WINDOWS,
  SAVE: () => SAVE,
  SEARCH: () => SEARCH,
  SETTINGS: () => SETTINGS,
  SHARE: () => SHARE,
  TRASH: () => TRASH,
  VIDEO: () => VIDEO
});
import { html } from "lit";
var ARROW_RIGHT = (classes) => html`<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 19 18"
    class=${classes}
  >
    <path
      fill="currentColor"
      d="M16.961 8.555a.71.71 0 0 1 0 1.003l-4.654 4.654a.71.71 0 1 1-1.003-1.003l4.153-4.152-4.153-4.152a.71.71 0 1 1 1.003-1.003l4.654 4.653Z M1.149 8.3h15v1.5h-15z"
    />
  </svg>`;
var ARROW_RIGHT_MINI = (classes) => html`<svg
    class=${classes}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line
      x1="1"
      y1="8.5"
      x2="16"
      y2="8.5"
      stroke="currentColor"
    />
    <path
      d="M12 4L16.1464 8.14645C16.3417 8.34171 16.3417 8.65829 16.1464 8.85355L12 13"
      stroke="currentColor"
      stroke-linecap="round"
    />
  </svg>`;
var AUDIO = (classes) => html`<svg
    class=${classes}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="9"
      cy="9"
      r="8.5"
      stroke="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.7215 12.1873C13.7215 12.7838 13.238 13.2673 12.6415 13.2673H12.1015C11.8033 13.2673 11.5615 13.0255 11.5615 12.7273V10.0273C11.5615 9.72905 11.8033 9.48729 12.1015 9.48729L12.9655 9.48726V8.72577C12.9655 6.39299 11.1259 4.50576 8.86154 4.50576C6.6407 4.50576 4.82845 6.3211 4.75957 8.59169L4.75754 8.72577V9.48726L5.62154 9.48729C5.91977 9.48729 6.16154 9.72905 6.16154 10.0273V12.7273C6.16154 13.0255 5.91977 13.2673 5.62154 13.2673H5.08154C4.48507 13.2673 4.00154 12.7838 4.00154 12.1873V8.72577C4.00154 5.97972 6.17524 3.74976 8.86154 3.74976C11.5007 3.74976 13.6451 5.90217 13.7195 8.58172L13.7215 8.72577V12.1873Z"
      fill="currentColor"
    />
  </svg>`;
var BURGER = (classes) => html`<svg
    class=${classes}
    viewBox="0 0 30 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 4.5L30 4.5V5.5L0 5.5L0 4.5ZM0 12.5L30 12.5V13.5L0 13.5L0 12.5ZM30 20.5L0 20.5L0 21.5L30 21.5V20.5Z"
      fill="currentColor"
    />
  </svg>`;
var CALENDAR = (classes) => html`
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="${classes}"
  >
    <path
      id="Combined Shape"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.31427 7.30779C1.31427 7.66912 1.0214 7.962 0.660069 7.962C0.298741 7.962 0.00586319 7.66912 0.00586319 7.30779V2.34544C0.00589482 1.07261 1.04142 0.0371094 2.31425 0.0371094H13.6857C14.9585 0.0371094 15.994 1.07261 15.9941 2.34544V7.30779C15.9941 7.66912 15.7012 7.962 15.3399 7.962C14.9785 7.962 14.6856 7.66912 14.6856 7.30779V2.34544C14.6856 1.79409 14.2371 1.34552 13.6857 1.34552H2.31422C1.76284 1.34552 1.31427 1.79409 1.31427 2.34544V7.30779ZM4.00587 5.03711C4.00587 4.48482 4.45359 4.03711 5.00587 4.03711C5.55816 4.03711 6.00587 4.48482 6.00587 5.03711C6.00587 5.58939 5.55816 6.03711 5.00587 6.03711C4.45359 6.03711 4.00587 5.58939 4.00587 5.03711ZM0.660066 8.03711C1.02139 8.03711 1.31427 8.32999 1.31427 8.69132V13.6537C1.31427 14.205 1.76284 14.6536 2.31421 14.6536H13.6857C14.2371 14.6536 14.6857 14.205 14.6857 13.6537V8.69132C14.6857 8.32999 14.9785 8.03711 15.3399 8.03711C15.7012 8.03711 15.9941 8.32999 15.9941 8.69132V13.6537C15.994 14.9265 14.9585 15.962 13.6857 15.962H2.31424C1.04142 15.962 0.00589101 14.9265 0.00585938 13.6537V8.69132C0.00585938 8.32999 0.298737 8.03711 0.660066 8.03711ZM4.00587 8.03711C4.00587 7.48482 4.45359 7.03711 5.00587 7.03711C5.55816 7.03711 6.00587 7.48482 6.00587 8.03711C6.00587 8.58939 5.55816 9.03711 5.00587 9.03711C4.45359 9.03711 4.00587 8.58939 4.00587 8.03711ZM5.00587 10.0371C4.45359 10.0371 4.00587 10.4848 4.00587 11.0371C4.00587 11.5894 4.45359 12.0371 5.00587 12.0371C5.55816 12.0371 6.00587 11.5894 6.00587 11.0371C6.00587 10.4848 5.55816 10.0371 5.00587 10.0371ZM7.00587 5.03711C7.00587 4.48482 7.45359 4.03711 8.00587 4.03711C8.55816 4.03711 9.00587 4.48482 9.00587 5.03711C9.00587 5.58939 8.55816 6.03711 8.00587 6.03711C7.45359 6.03711 7.00587 5.58939 7.00587 5.03711ZM8.00587 7.03711C7.45359 7.03711 7.00587 7.48482 7.00587 8.03711C7.00587 8.58939 7.45359 9.03711 8.00587 9.03711C8.55816 9.03711 9.00587 8.58939 9.00587 8.03711C9.00587 7.48482 8.55816 7.03711 8.00587 7.03711ZM7.00587 11.0371C7.00587 10.4848 7.45359 10.0371 8.00587 10.0371C8.55816 10.0371 9.00587 10.4848 9.00587 11.0371C9.00587 11.5894 8.55816 12.0371 8.00587 12.0371C7.45359 12.0371 7.00587 11.5894 7.00587 11.0371ZM11.0059 4.03711C10.4536 4.03711 10.0059 4.48482 10.0059 5.03711C10.0059 5.58939 10.4536 6.03711 11.0059 6.03711C11.5582 6.03711 12.0059 5.58939 12.0059 5.03711C12.0059 4.48482 11.5582 4.03711 11.0059 4.03711ZM10.0059 8.03711C10.0059 7.48482 10.4536 7.03711 11.0059 7.03711C11.5582 7.03711 12.0059 7.48482 12.0059 8.03711C12.0059 8.58939 11.5582 9.03711 11.0059 9.03711C10.4536 9.03711 10.0059 8.58939 10.0059 8.03711ZM11.0059 10.0371C10.4536 10.0371 10.0059 10.4848 10.0059 11.0371C10.0059 11.5894 10.4536 12.0371 11.0059 12.0371C11.5582 12.0371 12.0059 11.5894 12.0059 11.0371C12.0059 10.4848 11.5582 10.0371 11.0059 10.0371Z"
      fill="currentColor"
    />
  </svg>
`;
var CHAT = (classes) => html`<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 18"
    fill="none"
    class=${classes}
  >
    <path
      d="M9.28088 1.80078H8.8295C5.12169 1.80078 2.05872 4.76979 2.05872 8.36386V8.8014C2.05872 10.114 2.44562 11.3016 3.1227 12.333L1.80078 16.0208L5.60531 14.5832C6.57257 15.0832 7.63655 15.3645 8.79725 15.3645H9.24864C12.9564 15.3645 16.0194 12.3955 16.0194 8.8014V8.36386C16.0517 4.73854 12.9887 1.80078 9.28088 1.80078Z"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>`;
var CHECKMARK = (classes) => html`<svg
    class=${classes}
    viewBox="0 0 43 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32.25 13.5399L19.7084 30.5607L10.75 23.3941"
      stroke="currentColor"
      stroke-width="1.79167"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <circle
      cx="21.5"
      cy="22.4982"
      r="20.6042"
      stroke="currentColor"
      stroke-width="1.79167"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>`;
var CHEVRON = (classes) => html`<svg
    class=${classes}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.58907 12.3013C9.26369 12.6273 8.73618 12.6273 8.41083 12.3013L2.94397 6.8248C2.61862 6.49887 2.6186 5.97043 2.94397 5.64448C3.26935 5.31852 3.79686 5.31855 4.12221 5.64448L8.99995 10.5309L13.8777 5.64448C14.2031 5.31853 14.7306 5.31855 15.0559 5.64448C15.3813 5.97041 15.3813 6.49884 15.0559 6.8248L9.58907 12.3013Z"
      fill="currentColor"
    />
  </svg>`;
var CLEAR = (classes) => html`<svg
    xmlns="http://www.w3.org/2000/svg"
    class=${classes}
    viewBox="0 0 18 18"
    fill="none"
  >
    <g clip-path="url(#clip0_3293_99333)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM5.32727 5.32715C5.57303 5.08139 5.97148 5.08139 6.21723 5.32715L9.00007 8.10998L11.7829 5.32715C12.0287 5.08139 12.4271 5.08139 12.6729 5.32715C12.9186 5.57291 12.9186 5.97136 12.6729 6.21711L9.89003 8.99994L12.6729 11.7828C12.9187 12.0286 12.9187 12.427 12.6729 12.6728C12.4272 12.9186 12.0287 12.9186 11.783 12.6728L9.00007 9.88991L6.21718 12.6728C5.97142 12.9186 5.57297 12.9186 5.32721 12.6728C5.08146 12.427 5.08146 12.0286 5.32721 11.7828L8.1101 8.99994L5.32727 6.21711C5.08151 5.97135 5.08151 5.5729 5.32727 5.32715Z"
        fill="currentColor"
        fill-opacity="0.4"
      />
    </g>
    <defs>
      <clipPath id="clip0_3293_99333">
        <rect
          width="18"
          height="18"
          fill="currentColor"
        />
      </clipPath>
    </defs>
  </svg>`;
var CLOSE = (classes) => html`<svg
    xmlns="http://www.w3.org/2000/svg"
    class=${classes}
    viewBox="0 0 18 16"
    fill="none"
  >
    <g clip-path="url(#clip0_2290_63294)">
      <line
        x1="0.530736"
        y1="0.470076"
        x2="15.5078"
        y2="15.4701"
        stroke="currentColor"
        stroke-width="1.5"
      />
      <line
        x1="0.434652"
        y1="15.469"
        x2="15.4701"
        y2="0.469043"
        stroke="currentColor"
        stroke-width="1.5"
      />
    </g>
  </svg>`;
var CLOSE_MODAL = (classes) => html`<svg
    xmlns="http://www.w3.org/2000/svg"
    class=${classes}
    viewBox="0 0 41 29"
    fill="none"
  >
    <path
      id="Combined Shape"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.9592 14.5L6.1665 28.2927L6.87382 29L20.6665 15.2073L34.4592 29L35.1665 28.2927L21.3738 14.5L35.1665 0.707318L34.4592 0L20.6665 13.7927L6.87382 0L6.1665 0.707317L19.9592 14.5Z"
      fill="currentColor"
    />
  </svg>`;
var DELETE = (classes) => html`<svg
    xmlns="http://www.w3.org/2000/svg"
    class=${classes}
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M11.6957 3.08696L10.7503 12.0656C10.6945 12.5965 10.2469 12.9997 9.71304 13H4.28696C3.75288 13 3.30503 12.5967 3.24922 12.0656L2.30435 3.08696"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1 3.08696H13"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.65217 3.08696V1.52174C4.65217 1.23359 4.88576 1 5.17391 1H8.82609C9.11423 1 9.34783 1.23359 9.34783 1.52174V3.08696"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7 5.43478V10.913"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.34783 5.43478L9.08696 10.913"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.65217 5.43478L4.91304 10.913"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>`;
var DISABLED = (classes) => html`<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 18"
    class=${classes}
  >
    <circle
      cy="9"
      cx="9"
      r="8"
      fill="none"
      stroke="currentColor"
      stroke-width="1.5"
    />
    <line
      x1="3"
      y1="15"
      x2="15"
      y2="3"
      stroke="currentColor"
      stroke-width="1.5"
    />
  </svg>`;
var EMAIL = (classes) => html`<svg
    class=${classes}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15 3C16.1046 3 17 3.89543 17 5V13C17 14.1046 16.1046 15 15 15H3C1.89543 15 1 14.1046 1 13V5C1 3.89543 1.89543 3 3 3H15ZM2.299 5.007L2.3 13C2.3 13.3544 2.56334 13.6473 2.90501 13.6936L3 13.7H15C15.3544 13.7 15.6473 13.4367 15.6936 13.095L15.7 13V5.034L9.37049 9.52994C9.17265 9.67045 8.91587 9.68759 8.70369 9.58155L8.61579 9.52856L2.299 5.007ZM14.489 4.299H3.544L8.995 8.201L14.489 4.299Z"
      fill="currentColor"
    />
  </svg>`;
var EXTERNAL_LINK = (classes) => html`<svg
    class=${classes}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.0601 8.07504C12.6988 8.07504 12.4059 8.36792 12.4059 8.72925V13.6916C12.4059 14.2429 11.9573 14.6915 11.4059 14.6915H2.30832C1.75698 14.6915 1.30841 14.2429 1.30841 13.6916V4.59397C1.30841 4.04263 1.75698 3.59406 2.30832 3.59406H7.27066C7.63196 3.59406 7.92487 3.30115 7.92487 2.93985C7.92487 2.57855 7.63196 2.28564 7.27066 2.28564H2.30832C1.03553 2.28564 0 3.32117 0 4.59397V13.6916C0 14.9644 1.03553 15.9999 2.30832 15.9999H11.4059C12.6787 15.9999 13.7143 14.9644 13.7143 13.6916V8.72925C13.7143 8.36792 13.4214 8.07504 13.0601 8.07504Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.4038 0H10.8819C10.5526 0 10.2857 0.266916 10.2857 0.596151C10.2857 0.925387 10.5526 1.1923 10.8819 1.1923H14.8077V5.11813C14.8077 5.44737 15.0746 5.71429 15.4038 5.71429C15.7331 5.71429 16 5.44737 16 5.11813V0.596151C16 0.266916 15.7331 0 15.4038 0Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.8106 0.189378C15.5581 -0.0631261 15.1486 -0.0631261 14.8961 0.189378L5.9037 9.1818C5.65116 9.43434 5.65116 9.84377 5.9037 10.0963C6.02995 10.2226 6.19547 10.2857 6.36096 10.2857C6.52648 10.2857 6.69197 10.2226 6.81822 10.0963L15.8106 1.10388C16.0631 0.851343 16.0631 0.441914 15.8106 0.189378Z"
      fill="currentColor"
    />
  </svg>`;
var EYE = (classes) => html`<svg
    class=${classes}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 9C15 9 12.3137 13 9 13C5.68629 13 3 9 3 9C3 9 5.68629 5 9 5C12.3137 5 15 9 15 9Z"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <circle
      cx="9"
      cy="9"
      r="2"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>`;
var FILE = (classes) => html`<svg
    class=${classes}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.1697 1C10.7001 1 11.2087 1.21065 11.5838 1.58561L14.414 4.41518C14.7892 4.79027 15 5.29905 15 5.82957V15C15 16.1046 14.1046 17 13 17H5C3.89543 17 3 16.1046 3 15V3C3 1.89543 3.89543 1 5 1H10.1697ZM10.1697 2.3H5C4.64562 2.3 4.35274 2.56334 4.30639 2.90501L4.3 3V15C4.3 15.3544 4.56334 15.6473 4.90501 15.6936L5 15.7H13C13.3544 15.7 13.6473 15.4367 13.6936 15.095L13.7 15V5.82957C13.7 5.68103 13.6528 5.53735 13.5667 5.41861L13.4949 5.33454L10.6646 2.50496C10.5596 2.39997 10.4247 2.33179 10.2799 2.30872L10.1697 2.3Z"
      fill="currentColor"
    />
  </svg>`;
var FILTER = (classes) => html`<svg
    class=${classes}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M21.811 2.1C22.0383 1.79698 22.0748 1.39157 21.9054 1.05279C21.736 0.714002 21.3898 0.5 21.011 0.5H2.99C2.61123 0.5 2.26496 0.714002 2.09557 1.05279C1.92618 1.39157 1.96274 1.79698 2.19 2.1L10 12.592V22.5C10 23.0523 10.4477 23.5 11 23.5H13C13.5523 23.5 14 23.0523 14 22.5V12.592L21.811 2.1Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>`;
var GLOBE = (classes) => html`<svg
    class=${classes}
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.9031 5.99258C17.2448 2.75825 13.8778 0.537842 10 0.537842C6.12092 0.537842 2.75348 2.7591 1.09566 5.99576C1.08908 6.00871 1.08122 6.02039 1.07613 6.03398C0.389564 7.38864 0 8.91823 0 10.5378C0 12.1579 0.389564 13.6875 1.07613 15.0417C1.08122 15.0553 1.08908 15.067 1.09566 15.0799C2.75306 18.3166 6.12092 20.5378 10 20.5378C13.8778 20.5378 17.2448 18.3179 18.9031 15.0831C18.9105 15.0687 18.9192 15.0557 18.9247 15.0404C19.6109 13.6862 20 12.157 20 10.5378C20 8.91866 19.6109 7.38949 18.9247 6.03525C18.9188 6.01997 18.9105 6.00702 18.9031 5.99258ZM18.2369 14.4509H14.4151C14.6274 13.3796 14.7535 12.2082 14.7773 10.9726H19.1084C19.0495 12.2131 18.7443 13.3875 18.2369 14.4509ZM10 19.6683C8.62475 19.6683 7.3913 17.9052 6.69179 15.3205H13.3082C12.6087 17.9052 11.3753 19.6683 10 19.6683ZM6.48395 14.4509C6.25913 13.3818 6.12305 12.2061 6.09693 10.9726H13.9035C13.877 12.2061 13.7409 13.3818 13.5165 14.4509H6.48395ZM0.891644 10.9726H5.2227C5.2469 12.2082 5.37258 13.3796 5.58488 14.4509H1.76312C1.25573 13.3875 0.95045 12.2131 0.891644 10.9726ZM1.76312 6.6248H5.58488C5.37258 7.69604 5.24648 8.8675 5.2227 10.1031H0.891644C0.95045 8.86261 1.25573 7.68819 1.76312 6.6248ZM10 1.40741C11.3753 1.40741 12.6087 3.17053 13.3082 5.75523H6.69179C7.3913 3.17053 8.62475 1.40741 10 1.40741ZM13.5161 6.6248C13.7409 7.6935 13.877 8.86962 13.9031 10.1031H6.09651C6.12305 8.86962 6.25913 7.6935 6.48353 6.6248H13.5161ZM14.7773 10.1031C14.7531 8.8675 14.6274 7.69604 14.4151 6.6248H18.2369C18.7443 7.68819 19.0495 8.86261 19.1084 10.1031H14.7773ZM17.7626 5.75523H14.2183C13.7782 4.03011 13.1036 2.62302 12.2769 1.70653C14.586 2.30266 16.5391 3.77663 17.7626 5.75523ZM7.7227 1.70653C6.89644 2.62302 6.22176 4.03011 5.78125 5.75523H2.23696C3.46085 3.77663 5.41398 2.30266 7.7227 1.70653ZM2.23739 15.3205H5.78125C6.22134 17.0456 6.89602 18.4527 7.7227 19.3692C5.41398 18.773 3.46085 17.2986 2.23739 15.3205ZM12.2773 19.3692C13.1036 18.4527 13.7782 17.0456 14.2188 15.3205H17.7626C16.5391 17.2986 14.586 18.773 12.2773 19.3692Z"
      fill="currentColor"
    />
  </svg>`;
var HANDLE = (classes) => html`<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    class=${classes}
  >
    <path
      d="M8 4L8 20"
      stroke="currentColor"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-dasharray="0.1 7.8"
    />
    <path
      d="M16 4L16 20"
      stroke="currentColor"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-dasharray="0.1 7.8"
    />
  </svg>`;
var HEART_FILLED = (classes) => html`<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 18"
    fill="none"
    class=${classes}
  >
    <path
      d="M9.08373 15.8843C9.03755 15.8833 8.99268 15.8687 8.95472 15.8424C8.66121 15.6295 1.80078 10.5947 1.80078 6.72096C1.80078 4.29223 3.47154 2.82145 5.11972 2.6247C6.47116 2.46021 8.24513 3.14722 9.08373 5.50821C9.92234 3.15044 11.6866 2.46021 13.0478 2.6247C14.6992 2.82145 16.3667 4.29223 16.3667 6.72096C16.3667 10.5914 9.50626 15.6295 9.21275 15.8424C9.17479 15.8687 9.12992 15.8833 9.08373 15.8843ZM5.53579 3.04078C5.41934 3.04166 5.30304 3.0492 5.18745 3.06336C3.72957 3.2343 2.25879 4.54704 2.25879 6.72096C2.25879 10.0915 8.14514 14.6683 9.09986 15.3876C10.0675 14.6683 15.9442 10.0915 15.9442 6.72096C15.9442 4.54704 14.4702 3.2343 13.0123 3.06336C11.6447 2.90531 9.95459 3.67296 9.31596 6.33391C9.29962 6.3776 9.27032 6.41526 9.23199 6.44185C9.19366 6.46844 9.14812 6.48268 9.10147 6.48268C9.05482 6.48268 9.00929 6.46844 8.97096 6.44185C8.93263 6.41526 8.90333 6.3776 8.88699 6.33391C8.27416 3.89551 6.81305 3.04078 5.51967 3.04078H5.53579Z"
      stroke="currentColor"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11 3.5L9 5.5L7.5 3.5L5.5 3L4 3.5L2.5 5L2 8L5 12L9 15.5L14.5 11L16 7L15.5 4.5L13.5 3L11 3.5Z"
      fill="currentColor"
    />
  </svg>`;
var HEART = (classes) => html`<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 18"
    fill="none"
    class=${classes}
  >
    <path
      d="M9.08373 15.8843C9.03755 15.8833 8.99268 15.8687 8.95472 15.8424C8.66121 15.6295 1.80078 10.5947 1.80078 6.72096C1.80078 4.29223 3.47154 2.82145 5.11972 2.6247C6.47116 2.46021 8.24513 3.14722 9.08373 5.50821C9.92234 3.15044 11.6866 2.46021 13.0478 2.6247C14.6992 2.82145 16.3667 4.29223 16.3667 6.72096C16.3667 10.5914 9.50626 15.6295 9.21275 15.8424C9.17479 15.8687 9.12992 15.8833 9.08373 15.8843ZM5.53579 3.04078C5.41934 3.04166 5.30304 3.0492 5.18745 3.06336C3.72957 3.2343 2.25879 4.54704 2.25879 6.72096C2.25879 10.0915 8.14514 14.6683 9.09986 15.3876C10.0675 14.6683 15.9442 10.0915 15.9442 6.72096C15.9442 4.54704 14.4702 3.2343 13.0123 3.06336C11.6447 2.90531 9.95459 3.67296 9.31596 6.33391C9.29962 6.3776 9.27032 6.41526 9.23199 6.44185C9.19366 6.46844 9.14812 6.48268 9.10147 6.48268C9.05482 6.48268 9.00929 6.46844 8.97096 6.44185C8.93263 6.41526 8.90333 6.3776 8.88699 6.33391C8.27416 3.89551 6.81305 3.04078 5.51967 3.04078H5.53579Z"
      stroke="currentColor"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>`;
var INFO = (classes) => html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="none"
    viewBox="0 0 18 18"
    class=${classes}
  >
    <g clip-path="url(#a)">
      <rect
        width="16.8"
        height="16.8"
        x=".6"
        y=".6"
        stroke="#141E55"
        stroke-width="1.2"
        rx="8.4"
      />
      <path
        fill="#141E55"
        fill-rule="evenodd"
        d="M9.813 6.056c.058-.134.087-.278.087-.431 0-.153-.03-.297-.087-.431A1.125 1.125 0 0 0 8.786 4.5c-.16 0-.31.03-.448.093a1.193 1.193 0 0 0-.36.246c-.102.102-.182.22-.24.355a1.075 1.075 0 0 0-.088.431c0 .153.03.297.087.431a1.133 1.133 0 0 0 .601.596c.138.058.288.087.448.087a1.115 1.115 0 0 0 .792-.328 1.2 1.2 0 0 0 .235-.355ZM7.879 7.92v5.58h1.78V7.919H7.88Z"
        clip-rule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path
          fill="#fff"
          d="M0 0h18v18H0z"
        />
      </clipPath>
    </defs>
  </svg>`;
var IT_ALERT = (classes) => html`<svg
    class=${classes}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="
  http://www.w3.org/2000/svg"
  >
    <path
      d="M17.2014 3.34329C14.1384 3.25373 12.5031 2.69294 10.0008 0.697384C7.49857 2.69294 5.86172 3.25373 2.79865 3.34329V12.2345C2.84476 14.3306 3.56972 15.358 5.97576 16.9934L10.0235 19.3515L13.8853 16.9934C16.2914 15.358 17.1553 14.3306 17.2014 12.2345V3.34329Z"
      stroke="currentColor"
      stroke-width="1"
    />
  </svg>`;
var MINUS = (classes) => html`<svg
    class=${classes}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15 8C15.5523 8 16 8.44772 16 9C16 9.55228 15.5523 10 15 10H3C2.44772 10 2 9.55228 2 9C2 8.44772 2.44772 8 3 8H15Z"
      fill="currentColor"
    />
  </svg>`;
var PEN_DETAILED = (classes) => html`<svg
    xmlns="http://www.w3.org/2000/svg"
    class=${classes}
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.644 15.6553L1.33334 16.6667L2.34467 12.3567L12.976 1.724C13.2261 1.47383 13.5653 1.33328 13.919 1.33328C14.2727 1.33328 14.6119 1.47383 14.862 1.724L16.2767 3.138C16.5268 3.38806 16.6674 3.72728 16.6674 4.081C16.6674 4.43471 16.5268 4.77393 16.2767 5.024L5.644 15.6553Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.8067 5.49666L12.5047 2.19533"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.8553 6.448L11.5613 3.138"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.812 15.4887L2.512 12.1887"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>`;
var PEN = (classes) => html`<svg
    xmlns="http://www.w3.org/2000/svg"
    class=${classes}
    viewBox="0 0 20 20"
    fill="none"
  >
    <rect
      id="Rectangle-path"
      x="14.4764"
      y="2.21594"
      width="4.7088"
      height="16.7037"
      transform="rotate(45 14.4764 2.21594)"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      id="Shape"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.66459 14.027L1.00003 19.0215L5.9945 17.3569L2.66459 14.027Z"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      id="Shape_2"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.8057 5.54488L14.4766 2.21576L15.0315 1.66091C15.9553 0.768656 17.4237 0.781417 18.3319 1.68959C19.2401 2.59776 19.2529 4.06621 18.3606 4.99003L17.8057 5.54488Z"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    />
  </svg>`;
var PERFORMANCE_DASHBOARD = (classes) => html`<svg
    class=${classes}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.28304 3.9375C1.28304 3.66136 1.50689 3.4375 1.78304 3.4375H21.448C21.723 3.4375 21.9464 3.65964 21.948 3.93468L21.9849 10.4857L21.9849 10.4882L21.9849 16.399C21.9849 16.6751 21.7611 16.899 21.4849 16.899H1.78304C1.50689 16.899 1.28304 16.6751 1.28304 16.399V3.9375ZM2.18304 4.3375V10.5193H8.1324L9.57983 7.61559C9.78021 7.2136 10.3679 7.25918 10.5038 7.68728L11.8977 12.0752L13.4228 5.59852C13.5439 5.0843 14.276 5.08478 14.3964 5.59921L15.3069 9.49049L15.8364 8.83639C16.0911 8.52177 16.5945 8.62441 16.7057 9.01363L16.9985 10.0382H21.0824L21.0502 4.3375H2.18304ZM21.0849 10.9382H16.6968C16.4735 10.9382 16.2773 10.7902 16.216 10.5756L16.0518 10.0007L15.4922 10.6919C15.2305 11.0152 14.7115 10.8963 14.6167 10.4913L13.9083 7.46351L12.4417 13.6914C12.3254 14.1855 11.6321 14.2119 11.4785 13.7282L9.94493 8.90054L8.81363 11.1701L8.68939 11.4193H8.41089H2.18304V15.999H21.0849V10.9382ZM0 17.5482H0.45H10.1745H10.6245V17.7191C10.6352 17.8116 10.6634 17.8942 10.7158 17.9577C10.769 18.0223 10.8565 18.0783 11.0054 18.0981H12.2561C12.405 18.0783 12.4925 18.0223 12.5457 17.9577C12.5949 17.8981 12.6227 17.8217 12.6348 17.736V17.5482H13.0848H22.8638H23.3138V17.9982V18.9884V19.066L23.2878 19.1392C23.1472 19.5345 22.9742 19.8784 22.6826 20.1306C22.3854 20.3877 22.02 20.5029 21.5934 20.5589L21.5643 20.5627H21.5349H1.73305H1.70659L1.68032 20.5596C1.22746 20.5061 0.821101 20.3449 0.515471 20.0476C0.206816 19.7473 0.0401274 19.3462 0.00158843 18.8887L0 18.8698V18.8509V17.9982V17.5482ZM0.9 18.4482V18.8308C0.926061 19.1019 1.01882 19.2816 1.14308 19.4025C1.26952 19.5255 1.46609 19.6239 1.76092 19.6627H21.5046C21.8258 19.6176 21.987 19.5423 22.0938 19.4499C22.2009 19.3572 22.3018 19.2058 22.4138 18.9087V18.4482H13.4798C13.4693 18.4799 13.4569 18.5114 13.4421 18.5421C13.3335 18.7687 13.1447 18.8786 12.9694 18.9397C12.8258 18.9898 12.688 18.9981 12.5855 18.9981H10.5875C10.3022 18.9981 10.0099 18.9052 9.84575 18.6164C9.81494 18.5622 9.79195 18.5053 9.7748 18.4482H0.9Z"
      fill="currentColor"
    />
  </svg>`;
var PHONE = (classes) => html`<svg
    class=${classes}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.50029 15.1044L5.81661 14.7843L5.80897 14.7767L5.80098 14.7696L5.50029 15.1044ZM19.1873 15.1044H19.6373C19.6373 14.9441 19.5521 14.796 19.4136 14.7154L19.1873 15.1044ZM14.3849 12.3097L14.6112 11.9208C14.4274 11.8138 14.1938 11.8501 14.0512 12.0078L14.3849 12.3097ZM11.7499 15.2219L11.5324 15.6158C11.7152 15.7168 11.9434 15.6787 12.0835 15.5238L11.7499 15.2219ZM5.31402 8.25034L4.98741 7.94078C4.86464 8.07031 4.83002 8.26016 4.89917 8.42469L5.31402 8.25034ZM7.8991 5.52282L8.22572 5.83237C8.35724 5.69361 8.38671 5.48689 8.29922 5.31689L7.8991 5.52282ZM5.31402 0.5L5.71414 0.294072C5.63464 0.139613 5.47334 0.0447039 5.29971 0.0502276L5.31402 0.5ZM19.4136 14.7154L14.6112 11.9208L14.1585 12.6987L18.961 15.4933L19.4136 14.7154ZM14.0512 12.0078L11.4162 14.92L12.0835 15.5238L14.7185 12.6117L14.0512 12.0078ZM11.9673 14.8279C9.84142 13.6543 8.6755 12.856 7.84593 11.9255C7.01773 10.9965 6.49873 9.90771 5.72887 8.07598L4.89917 8.42469C5.66598 10.2491 6.23401 11.4698 7.17413 12.5244C8.11286 13.5774 9.39653 14.4367 11.5324 15.6158L11.9673 14.8279ZM5.64063 8.55989L8.22572 5.83237L7.57249 5.21326L4.98741 7.94078L5.64063 8.55989ZM8.29922 5.31689L5.71414 0.294072L4.9139 0.705928L7.49899 5.72875L8.29922 5.31689ZM5.29971 0.0502276C3.47969 0.108128 2.1896 0.828874 1.41105 2.00003C0.647417 3.14875 0.418151 4.66713 0.562087 6.26002C0.849604 9.44188 2.6447 13.1444 5.19959 15.4391L5.80098 14.7696C3.41657 12.628 1.72566 9.13631 1.45844 6.17903C1.325 4.70235 1.55118 3.41494 2.16055 2.49827C2.75501 1.60404 3.75548 0.99981 5.32833 0.949772L5.29971 0.0502276ZM5.18396 15.4244C8.17984 18.3853 11.7084 19.9346 14.5431 19.9499C15.9642 19.9576 17.2433 19.578 18.1728 18.7541C19.1104 17.9231 19.6373 16.6886 19.6373 15.1044H18.7373C18.7373 16.4795 18.2872 17.45 17.5759 18.0806C16.8564 18.7182 15.8146 19.0567 14.5479 19.0499C12.0069 19.0362 8.69197 17.6261 5.81661 14.7843L5.18396 15.4244Z"
      fill="currentColor"
    ></path>
  </svg>`;
var PLAY = (classes) => html`<svg
    class=${classes}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 77 78"
    fill="none"
  >
    <rect
      opacity="0.01"
      x="0.832142"
      y="0.457142"
      width="75.1517"
      height="77.0857"
      stroke="currentColor"
      stroke-width="0.914285"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M45.645 38.8724C45.7142 38.9434 45.7142 39.0567 45.645 39.1277L36.2683 48.7428C36.1538 48.8603 35.9545 48.7792 35.9545 48.6152V29.385C35.9545 29.221 36.1538 29.1399 36.2683 29.2573L45.645 38.8724Z"
      fill="currentColor"
    />
    <rect
      x="4.63513"
      y="4.34302"
      width="67.5461"
      height="69.3143"
      stroke="currentColor"
      stroke-width="2"
    />
  </svg>`;
var PLUS = (classes) => html`<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 18"
    fill="none"
    class=${classes}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9 2C8.44772 2 8 2.44772 8 3V8H3C2.44772 8 2 8.44772 2 9C2 9.55228 2.44772 10 3 10H8V15C8 15.5523 8.44772 16 9 16C9.55228 16 10 15.5523 10 15V10H15C15.5523 10 16 9.55228 16 9C16 8.44772 15.5523 8 15 8H10V3C10 2.44772 9.55228 2 9 2Z"
      fill="currentColor"
    />
  </svg>`;
var PROFILE_CIRCLE = (classes) => html`<svg
    xmlns="http://www.w3.org/2000/svg"
    class=${classes}
    viewBox="0 0 26 26"
    fill="none"
  >
    <circle
      cx="13"
      cy="13"
      r="11.5"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <circle
      cx="13"
      cy="9.75"
      r="4.25"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.317 19.5C18.1617 17.0575 15.7019 15.4999 13 15.4999C10.2981 15.4999 7.83828 17.0575 6.683 19.5"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>`;
var PROFILE_THIN = (classes) => html`<svg
    xmlns="http://www.w3.org/2000/svg"
    class=${classes}
    viewBox="0 0 26 25"
    fill="none"
  >
    <path
      d="M17.6398 7.81242C17.6398 10.6452 15.3434 12.9416 12.5107 12.9416C9.6779 12.9416 7.38149 10.6452 7.38149 7.81242C7.38149 4.97966 9.6779 2.68325 12.5107 2.68325C15.3434 2.68325 17.6398 4.97966 17.6398 7.81242Z"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.23468 22.743C3.89652 18.7167 7.79743 15.625 12.5107 15.625C17.224 15.625 21.1249 18.7167 21.7867 22.743"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="square"
      stroke-linejoin="round"
    />
  </svg>`;
var PROFILE = (classes) => html`<svg
    class=${classes}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="9"
      cy="5.0625"
      r="4.125"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.25 17.0625C2.25 13.3346 5.27208 10.3125 9 10.3125C12.7279 10.3125 15.75 13.3346 15.75 17.0625H2.25Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>`;
var REFRESH = (classes) => html`<svg
    class=${classes}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.17975 14.25C1.43983 11.7356 1.09453 7.53681 3.38685 4.60854C5.67917 1.68027 9.83804 1.00747 12.9367 3.06363C16.0354 5.11979 17.0315 9.21327 15.2241 12.4633C13.4168 15.7134 9.41377 17.0268 6.03225 15.4793"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.52523 10.9443L4.19079 14.3027L0.83524 13.9685"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>`;
var REPLY_WINDOWS = (classes) => html`<svg
    xmlns="http://www.w3.org/2000/svg"
    class=${classes}
    viewBox="0 0 16 12"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.66667 3.636C6.66667 3.636 15 2.636 15 10.9693C12.3333 5.96933 6.66667 7.636 6.66667 7.636V10.3027L1 5.636L6.66667 0.96933V3.636Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>`;
var REPLY = (classes) => html`<svg
    xmlns="http://www.w3.org/2000/svg"
    class="${classes}"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M2 5.9082L13 5.9082C14.1046 5.9082 15 6.80363 15 7.9082V13.0001M2 5.9082L6 1.9082M2 5.9082L6 9.9082"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>`;
var SEARCH = (classes) => html`<svg
    class=${classes}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.3393 12.359C10.143 13.3307 8.61773 13.913 6.95641 13.913C3.11442 13.913 0 10.7986 0 6.95646C0 3.11454 3.11447 0 6.95641 0C10.7984 0 13.913 3.11458 13.913 6.95646C13.913 8.62731 13.324 10.1606 12.3423 11.3599C12.3876 11.3833 12.4301 11.4138 12.4681 11.4515L19.8502 18.7668C20.0504 18.9651 20.0504 19.2867 19.8503 19.485L19.5618 19.8496C19.3617 20.048 19.0371 20.048 18.837 19.8496L11.4548 12.5342C11.4028 12.4827 11.3643 12.4228 11.3393 12.359ZM12.9191 6.95681C12.9191 3.66379 10.2494 0.994141 6.95627 0.994141C3.66319 0.994141 0.993652 3.66374 0.993652 6.95681C0.993652 10.2501 3.66314 12.9196 6.95627 12.9196C10.2495 12.9196 12.9191 10.25 12.9191 6.95681Z"
      fill="currentColor"
    />
  </svg>`;
var SETTINGS = (classes) => html`<svg
    class=${classes}
    fill="none"
    viewBox="0 0 20 20"
  >
    <path
      fill-rule="evenodd"
      d="M 19.1 11.2 C 19.3 11.2 19.5 11 19.5 10.8 L 19.5 9.1 C 19.5 8.8 19.3 8.7 19.1 8.6 L 17.2 8.4 C 17.1 7.5 16.7 6.6 16.2 5.8 L 17.3 4.4 C 17.5 4.3 17.4 4 17.3 3.9 L 16 2.6 C 15.9 2.5 15.7 2.5 15.5 2.6 L 14.1 3.8 C 13.3 3.2 12.4 2.9 11.5 2.7 L 11.3 0.8 C 11.3 0.6 11.1 0.5 10.9 0.5 L 9.1 0.5 C 8.9 0.5 8.7 0.6 8.7 0.8 L 8.5 2.7 C 7.5 2.9 6.7 3.2 5.9 3.8 L 4.5 2.6 C 4.3 2.5 4.1 2.5 3.9 2.6 L 2.7 3.9 C 2.5 4 2.5 4.3 2.7 4.4 L 3.8 5.8 C 3.3 6.6 2.9 7.5 2.8 8.4 L 0.9 8.6 C 0.7 8.7 0.5 8.9 0.5 9.1 L 0.5 10.8 C 0.5 11 0.7 11.2 0.9 11.2 L 2.8 11.5 C 2.9 12.4 3.3 13.3 3.8 14 L 2.7 15.5 C 2.5 15.7 2.6 15.9 2.7 16.1 L 4 17.3 C 4.1 17.5 4.3 17.5 4.5 17.4 L 5.9 16.2 C 6.7 16.7 7.6 17.1 8.5 17.3 L 8.7 19.2 C 8.7 19.4 8.9 19.5 9.1 19.5 L 10.9 19.5 C 11.1 19.5 11.3 19.4 11.3 19.2 L 11.5 17.3 C 12.5 17.1 13.3 16.7 14.1 16.2 L 15.5 17.4 C 15.7 17.5 15.9 17.5 16.1 17.3 L 17.3 16.1 C 17.5 15.9 17.5 15.7 17.4 15.5 L 16.2 14 C 16.7 13.3 17.1 12.4 17.3 11.5 L 19.1 11.2 Z"
      stroke-width="0.9"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke="currentColor"
    ></path>
    <circle
      cx="10"
      cy="10"
      r="4"
      stroke-width="0.9"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke="currentColor"
    ></circle>
  </svg>`;
var SAVE = (classes) => html`
  <svg
    class="${classes}"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16 15.3913C16 15.7275 15.7275 16 15.3913 16H2.6087C2.27252 16 2 15.7275 2 15.3913V4.99113C2.00003 4.82971 2.06419 4.67491 2.17835 4.56078L4.56078 2.17835C4.67491 2.06419 4.82971 2.00003 4.99113 2H15.3913C15.7275 2 16 2.27252 16 2.6087V15.3913Z"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.8694 15.4928V9.59025C13.8694 9.26426 13.6129 9 13.2965 9H4.70314C4.38674 9 4.13025 9.26426 4.13025 9.59025V15.4928"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.04346 2H12.9565V5.65217C12.9565 5.98835 12.684 6.26087 12.3478 6.26087H5.65215C5.31598 6.26087 5.04346 5.98835 5.04346 5.65217V2Z"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
`;
var SHARE = (classes) => html`<svg
    class="${classes}"
    viewBox="0 0 22 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.5637 19.6498C19.1179 20.4216 18.2879 20.9009 17.3972 20.9C16.9602 20.9 16.5285 20.7846 16.1496 20.5652C14.9567 19.878 14.5461 18.3467 15.2324 17.1529L15.2351 17.1511L15.2359 17.1476C15.6818 16.3784 16.5117 15.9 17.4016 15.9C17.8377 15.9 18.2685 16.0163 18.6492 16.2348C19.2271 16.5687 19.6403 17.1079 19.8139 17.7546C19.9866 18.3978 19.8976 19.0727 19.5637 19.6498ZM4.60322 13.5C3.71134 13.5 2.88027 13.0208 2.43433 12.25C1.74516 11.0564 2.15584 9.52449 3.35001 8.83474C3.72985 8.6154 4.16169 8.5 4.59705 8.5C5.48893 8.5 6.31999 8.97921 6.76505 9.75C7.45511 10.9445 7.04442 12.4755 5.85026 13.1644C5.47042 13.3837 5.03858 13.5 4.60322 13.5ZM16.151 1.43562C16.5306 1.21628 16.9612 1.1 17.3981 1.1C18.2885 1.1 19.1182 1.58009 19.5638 2.35088C19.8976 2.92875 19.9866 3.60176 19.8139 4.24658C19.6404 4.8914 19.2274 5.43051 18.6496 5.76526C18.2691 5.9846 17.8385 6.1 17.4025 6.1C16.513 6.1 15.6842 5.62167 15.2376 4.85264L15.2332 4.84471C14.9021 4.26772 14.814 3.59559 14.9858 2.95254C15.1584 2.3086 15.5723 1.76948 16.151 1.43562ZM17.3746 14.7352C16.184 14.7352 15.3228 15.0553 14.6504 16.0248L8.02442 12.3074C8.34556 11.5658 8.34556 10.4057 8.02442 9.60336L14.4007 5.87133C15.0732 6.83976 16.185 7.26373 17.3746 7.26373C18.0077 7.26373 18.6344 7.0954 19.1855 6.77685C20.0239 6.29211 20.624 5.50906 20.8751 4.57153C21.1252 3.634 20.9975 2.65598 20.5123 1.8154C19.8665 0.69569 18.662 0 17.3693 0C16.7351 0 16.1095 0.168329 15.5584 0.486877C14.7189 0.971622 14.1188 1.75467 13.8677 2.69114C13.6442 3.53065 13.6442 4.30388 13.8677 4.88408L7.39481 8.67957C6.72343 7.68983 5.82922 7.36707 4.62265 7.36707C3.99064 7.36707 3.36395 7.5354 2.8128 7.85501C1.08063 8.8554 0.484792 11.082 1.48601 12.8154C2.13079 13.9362 3.33629 14.6319 4.6301 14.6319C5.26211 14.6319 5.88774 14.4635 6.43995 14.145C6.91768 13.8691 7.10009 13.7688 7.39481 13.3416L13.8677 17.106C13.1813 18.4604 13.9145 20.5649 15.5584 21.5131C16.1095 21.8317 16.7351 22 17.3693 22C18.662 22 19.8665 21.3043 20.5123 20.1835C20.9975 19.344 21.1252 18.3649 20.8751 17.4285C20.624 16.4909 20.0239 15.7079 19.1855 15.2231C18.6344 14.9046 18.0077 14.7352 17.3746 14.7352Z"
      fill="currentColor"
    />
  </svg>`;
var TRASH = (classes) => html`<svg
    xmlns="http://www.w3.org/2000/svg"
    class="${classes}"
    viewBox="0 0 22 19"
    fill="none"
  >
    <path
      d="M18.8261 3.98135L17.2505 16.8079C17.1575 17.5664 16.4116 18.1424 15.5218 18.1428H6.4783C5.58817 18.1428 4.84175 17.5667 4.74873 16.8079L3.17395 3.98135"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1 3.98135H21"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.08698 3.98137V1.74534C7.08698 1.3337 7.47629 1 7.95654 1H14.0435C14.5237 1 14.9131 1.3337 14.9131 1.74534V3.98137"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>`;
var VIDEO = (classes) => html`<svg
    class=${classes}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="9"
      cy="9"
      r="8.5"
      stroke="currentColor"
    />
    <path
      d="M8.43757 12.2452C7.77105 12.6451 6.92308 12.165 6.92308 11.3877V6.61238C6.92308 5.83509 7.77105 5.35497 8.43757 5.75489L12.417 8.14254C13.0643 8.53095 13.0643 9.46913 12.417 9.85753L8.43757 12.2452Z"
      fill="currentColor"
    />
  </svg>`;

export {
  ARROW_RIGHT,
  ARROW_RIGHT_MINI,
  AUDIO,
  BURGER,
  CALENDAR,
  CHAT,
  CHECKMARK,
  CHEVRON,
  CLEAR,
  CLOSE,
  CLOSE_MODAL,
  DELETE,
  DISABLED,
  EMAIL,
  EXTERNAL_LINK,
  EYE,
  FILE,
  FILTER,
  GLOBE,
  HANDLE,
  HEART_FILLED,
  HEART,
  INFO,
  IT_ALERT,
  MINUS,
  PEN_DETAILED,
  PEN,
  PERFORMANCE_DASHBOARD,
  PHONE,
  PLAY,
  PLUS,
  PROFILE_CIRCLE,
  PROFILE_THIN,
  PROFILE,
  REFRESH,
  REPLY_WINDOWS,
  REPLY,
  SEARCH,
  SETTINGS,
  SAVE,
  SHARE,
  TRASH,
  VIDEO,
  consts_exports
};
